import { useCoreService } from 'core/services/useCoreService';
import { createContext } from 'react';
import { useDataFetcher } from 'shared/http';
import { useNotifications } from 'shared/notifications';
import { LoadingSpinner } from 'shared/spinner/components/LoadingSpinner';
import { TemplateError } from '../models/errors/TemplateError';

interface IMassFundsDistributionContext {
  availableCostCentres: any;
  downloadTemplate: (parentCostCentre: any, selectedChildren: number[]) => Promise<any>;
  uploadTemplate: (file: File) => Promise<any>;
}

export const MassFundsDistributionContext = createContext<IMassFundsDistributionContext>({
  availableCostCentres: null,
  downloadTemplate: () => null,
  uploadTemplate: () => null,
});

export const MassFundsDistributionProvider = ({ children }) => {
  const [availableCostCentres] = useDataFetcher<any>();
  const coreService = useCoreService();
  const { addNotification } = useNotifications();

  const value = {
    availableCostCentres: availableCostCentres?.data || null,
    downloadTemplate: (centroCostoPadre: any, centroCostoIds: number[]) =>
      coreService
        .getMassDistributionTemplate({ padreId: centroCostoPadre.id, centroCostoIds })
        .then((data) => {
          addNotification('Su descarga comenzará en breve', 'info');
          return data.body;
        })
        .then((res) => {
          const url = URL.createObjectURL(res.file);
          return {
            url,
            name: res.name,
          };
        })
        .catch((err) => {
          const message = new TemplateError(err.error).message;
          addNotification(message, 'error');
          return null;
        }),
    uploadTemplate: (file: File) => new Promise(() => {}),
  };

  return (
    <MassFundsDistributionContext.Provider value={value}>
      <LoadingSpinner isLoading={availableCostCentres.isLoading}>
        {availableCostCentres.data && children}
      </LoadingSpinner>
    </MassFundsDistributionContext.Provider>
  );
};
